/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedStoresNearbyResponse } from '../../models/paginated-stores-nearby-response';

export interface StoresNearby$Params {

/**
 * if the response includes the delivery zones for each returned store
 */
  includeDeliveryZones?: boolean;

/**
 * filter for enabled / disabled / all delivery zones - if not filled assumes all
 */
  enabledDeliveryZones?: boolean;

/**
 * filter for Primary / Secondary / all delivery zones - if not filled assumes all
 */
  deliveryZoneType?: 'Primary' | 'Secondary';

/**
 * location’s latitude
 */
  latitude: number;

/**
 * location’s longitude
 */
  longitude: number;

/**
 * radius in kms to filter the nearby stores - if not filled, a 30 kms default will be assumed
 */
  radius?: number;
  page?: number;
  size?: number;
}

export function storesNearby(http: HttpClient, rootUrl: string, params: StoresNearby$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedStoresNearbyResponse>> {
  const rb = new RequestBuilder(rootUrl, storesNearby.PATH, 'get');
  if (params) {
    rb.query('includeDeliveryZones', params.includeDeliveryZones, {});
    rb.query('enabledDeliveryZones', params.enabledDeliveryZones, {});
    rb.query('deliveryZoneType', params.deliveryZoneType, {});
    rb.query('latitude', params.latitude, {});
    rb.query('longitude', params.longitude, {});
    rb.query('radius', params.radius, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedStoresNearbyResponse>;
    })
  );
}

storesNearby.PATH = '/stores-nearby';
